export default {"src":"/_next/static/media/cart.83d8acc2.svg","height":19,"width":23,"blurWidth":0,"blurHeight":0};